import Field from "./Field";
import Form from "./Form";

/**
 * @author Andrea Moraglia
 */
export default class TextField extends Field {

    constructor($input: JQuery, form: Form, type: string = "string") {
        super($input, form, type);
    }

    getValue(): Record<string, unknown> {
        return super.processValue(this.selector.val());
    }

    setValue(value: string): void {
        this.selector.val(value).trigger("change");
    }

    isValid(): boolean {
        if (this.isRequired() && !this.selector.val()) return false;
        if (!this.isRequired() && !this.selector.val()) return true;
        return super.processValid(this.getValue());
    }

    clear(): void {
        this.setValue("");
    }

}